import { render } from "./BaseCard.vue?vue&type=template&id=aa087aec&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=aa087aec&lang=scss&scoped=true"

import exportComponent from "H:\\_LK\\workInProgress\\invoice-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa087aec"]])

export default __exports__